<video #video [autoplay]="autoplay" [muted]="'muted'" loop (click)="pause()" *ngIf="url">
  <source [src]="url" type="video/mp4" />
</video>
